import { useContext, useMemo } from 'react';
import type { Chart as IChart } from '@trinity/chat';
import { ChatAttachmentType } from '@trinity/chat';
import { AttachmentsContext } from '@trinity/chat-components/components/Chat/context';
import { Chart } from './Chart';
import { AttachmentContext } from './context';
import { Table } from './Table';

type Props = {
  id: string;
};

export const Item = (props: Props) => {
  const attachments = useContext(AttachmentsContext);
  const attachment = useMemo(() => attachments.find(x => x.id === props.id), [attachments, props.id]);

  switch (attachment?.type) {
    case ChatAttachmentType.Chart: {
      const { values, ...other } = attachment.data;

      const item = {
        ...other,
        data: values,
      } as IChart['chart'];

      return <Chart item={item} type={attachment.data.type} />;
    }

    case ChatAttachmentType.Table: {
      return (
        <AttachmentContext.Provider value={attachment}>
          <Table item={attachment} />
        </AttachmentContext.Provider>
      );
    }

    default: {
      console.error(`Unsupported attachment type: ${attachment?.type}`);
      return null;
    }
  }

};

Item.displayName = 'Chat.Attachments.Item';